/**
 * Tire upsell ("Complete the Package") + tire-line dedupe. One file, loaded once from
 * layout/theme.liquid, wrapping fetch once.
 *
 * The box itself (snippets/wbr-tire-upsell.liquid) is empty markup; everything shown
 * in it is derived here from /cart.js: the newest wheel line gives the diameter and
 * quantity, the finder's saved vehicle (localStorage "ymm") gives AutoSync's recommended
 * tire sizes for that diameter, and /collections/<D>-tires?view=wbr-json&filter... gives
 * real, in-stock tire products for each size. Shoppers add tires without leaving the cart.
 * Without a saved vehicle it falls back to the store's default size per diameter plus
 * 33"/35" flotation sizes - the same three choices the old link buttons offered.
 */
(function () {
  if (window.__wbrTireUpsell) return;
  window.__wbrTireUpsell = true;

  var nativeFetch = window.fetch && window.fetch.bind(window);
  if (!nativeFetch) return;

  var CART_MUTATION_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  /* ---------- cart helpers ---------- */

  function getCart() {
    return nativeFetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }
  function changeLine(key, quantity) {
    return nativeFetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity: quantity }),
    });
  }
  function isTireItem(item) { return (item.product_type || '').toLowerCase().indexOf('tire') !== -1; }
  function isWheelItem(item) { return (item.product_type || '').toLowerCase().indexOf('wheel') !== -1; }

  // A silent removal reads as a glitch ("why did my tire disappear?"). Confirm what happened.
  function showToast(message) {
    var el = document.createElement('div');
    el.textContent = message; el.setAttribute('role', 'status');
    el.style.cssText = ['position:fixed', 'left:50%', 'bottom:24px', 'transform:translateX(-50%)',
      'background:#1a1a1a', 'color:#fff', 'padding:12px 20px', 'border-radius:6px', 'font-size:14px',
      'line-height:1.4', 'max-width:90vw', 'text-align:center', 'z-index:99999',
      'box-shadow:0 4px 16px rgba(0,0,0,.25)', 'opacity:0', 'transition:opacity .25s ease'].join(';');
    document.body.appendChild(el);
    requestAnimationFrame(function () { el.style.opacity = '1'; });
    setTimeout(function () { el.style.opacity = '0'; setTimeout(function () { el.remove(); }, 250); }, 3500);
  }

  /* ---------- dedupe ---------- */

  // Picking a different tire size should replace what is already in the cart, not stack
  // up alongside it. Shopify's AJAX cart puts a NEWLY ADDED line at the FRONT of
  // cart.items (verified live), so tires[0] is the one the shopper just chose.
  // Resolves to the kept item when something was removed, otherwise null.
  function dedupeTires(cart) {
    var tires = cart.items.filter(isTireItem);
    if (tires.length <= 1) return Promise.resolve(null);
    var keep = tires[0];
    var toRemove = tires.filter(function (t) { return t.key !== keep.key; });

    // Carry the shopper's quantity across (largest, not the sum, so a size swap never
    // multiplies the order). Quantity FIRST, removals second: an interrupted run then
    // leaves too many tires rather than too few - "cart says 4, checkout says 1" was
    // the other order.
    var wanted = keep.quantity;
    toRemove.forEach(function (t) { if (t.quantity > wanted) wanted = t.quantity; });
    var chain = wanted === keep.quantity ? Promise.resolve(true)
      : changeLine(keep.key, wanted).then(function (res) { return res.ok; });
    toRemove.forEach(function (t) {
      chain = chain.then(function (allOk) { return changeLine(t.key, 0).then(function (res) { return allOk && res.ok; }); });
    });
    return chain.then(function (allOk) { return allOk ? keep : null; });
  }

  /* ---------- the upsell box ---------- */

  var SIZE_RE = /^(?:LT|P|ST)?(\d+(?:\.\d+)?)\s*[\/Xx]\s*(\d+(?:\.\d+)?)\s*[RBDZ]?\s*(\d+(?:\.\d+)?)/i;
  var DEFAULT_METRIC = { 15: '235/75R15', 16: '265/75R16', 17: '265/70R17', 18: '275/65R18', 19: '255/55R19',
                         20: '275/55R20', 21: '275/45R21', 22: '285/45R22', 24: '305/35R24', 26: '305/30R26',
                         28: '295/25R28', 30: '265/30R30' };
  var cache = {};

  function widgets() { return Array.prototype.slice.call(document.querySelectorAll('[id^="wbr-tire-upsell-"]')); }
  function money(cents) { return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function slug(s) { return s.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }
  function normSize(s) { return String(s || '').toUpperCase().replace(/^(LT|P|ST)/, '').replace(/[^0-9A-Z.]/g, '').replace(/(\d)Z?R(\d)/, '$1R$2').replace(/LT$/, ''); }

  function getJSON(url) {
    if (!cache[url]) cache[url] = nativeFetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); });
    return cache[url];
  }
  function saved() {
    try { var s = JSON.parse(localStorage.getItem('ymm') || 'null'); return s && s.y && s.mk && s.mo ? s : null; } catch (e) { return null; }
  }
  // 20" Wheels -> 20; else "MOTO METAL MO812 20x9 ..." -> 20
  function diameterOf(item) {
    var m = /(\d{2})"/.exec(item.product_type || '') || /\b(\d{2})\s*[xX]\s*\d/.exec(item.product_title || item.title || '');
    return m ? m[1] : null;
  }
  function tireUrl(size) {
    var m = SIZE_RE.exec(String(size || '')); if (!m) return null;
    return '/collections/' + m[3] + '-tires?' + encodeURIComponent('filter.v.option.tire width') + '=' + encodeURIComponent(m[1])
         + '&' + encodeURIComponent('filter.v.option.tire ratio') + '=' + encodeURIComponent(m[2]);
  }
  function defaultSizes(dia) {
    var out = [];
    if (DEFAULT_METRIC[dia]) out.push({ size: DEFAULT_METRIC[dia], n: 0, text: '', maybe: false });
    if (+dia >= 17 && +dia <= 24) { out.push({ size: '33x12.50R' + dia, n: 0, text: '', maybe: false }); out.push({ size: '35x12.50R' + dia, n: 0, text: '', maybe: false }); }
    return out;
  }

  // Recommended sizes at this diameter: the shopper's vehicle when the finder saved one
  // (AutoSync sizes, fitment notes judged at their setup, in-stock only, clean fits
  // first), else the store defaults.
  function sizesFor(box, dia) {
    var s = saved();
    if (!s || !box.dataset.src) return Promise.resolve({ vehicle: null, sizes: defaultSizes(dia) });
    var src = box.dataset.src, base = src.replace(/ymm-data\.json.*$/, ''), ver = src.split('?')[1] || '';
    return Promise.all([getJSON(src), getJSON(base + 'ymm-d-' + slug(s.mk) + '.json' + (ver ? '?' + ver : ''))])
      .then(function (res) {
        var bundle = res[0], detail = res[1], S = window.YMM_SETUP;
        var list = (detail.t && detail.t[s.mo] && detail.t[s.mo][dia]) || [];
        var trimKey = s.mo + '|' + (s.sb || '');
        var byTrim = detail.n && (detail.n[trimKey] || detail.n[Object.keys(detail.n).filter(function (k) { return k.indexOf(s.mo + '|') === 0; })[0]]);
        var notes = (byTrim && byTrim[dia]) || {};
        var stock = bundle.tires || {};
        var sizes = list.map(function (ts) {
          var code = notes[ts] || '', maybe = code.charAt(0) === '?', flags = maybe ? code.slice(1) : code;
          var need = S ? S.blockers(flags, S.setup()) : flags;
          return { size: ts, n: stock[ts.toUpperCase()] || 0, maybe: maybe,
                   text: need ? ((maybe ? 'may need ' : 'needs ') + (S ? S.words(need) : need)) : '' };
        }).filter(function (x) { return x.n > 0; })
          .sort(function (a, b) { return (a.text ? 1 : 0) - (b.text ? 1 : 0) || b.n - a.n; });
        return { vehicle: s.y + ' ' + s.mk + ' ' + s.mo + (s.sb ? ' ' + s.sb : ''), sizes: sizes.length ? sizes : defaultSizes(dia) };
      })
      .catch(function () { return { vehicle: null, sizes: defaultSizes(dia) }; });
  }

  function productsFor(size) {
    var url = tireUrl(size); if (!url) return Promise.resolve([]);
    return getJSON(url + '&view=wbr-json').then(function (j) { return j.products || []; }).catch(function () { return []; });
  }
  // Cheapest tire that can cover the wheel quantity; else cheapest available.
  function pick(products, qty) {
    var ok = products.filter(function (p) { return p.available && (p.qty >= qty || p.policy === 'continue'); });
    if (!ok.length) ok = products.filter(function (p) { return p.available; });
    ok.sort(function (a, b) { return a.price - b.price; });
    return ok[0] || null;
  }

  function card(rec, p, qty, inCart) {
    return '<div class="wtu__card">'
      + '<div class="wtu__top">' + (p.image ? '<img class="wtu__img" src="' + esc(p.image) + '" alt="" loading="lazy">' : '')
      + '<div class="wtu__info"><p class="wtu__size">' + esc(rec.size) + (rec.n ? '<small>' + rec.n + ' in stock</small>' : '') + '</p>'
      + '<p class="wtu__pname">' + esc(p.title) + '</p>'
      + '<p class="wtu__price">' + money(p.price) + '<small>each · ' + money(p.price * qty) + ' for ' + qty + '</small></p>'
      + (rec.text ? '<p class="wtu__note">' + esc(rec.text) + '</p>' : '') + '</div></div>'
      + '<button type="button" class="wtu__btn" data-wtu-add data-variant="' + p.variant_id + '" data-qty="' + qty + '" data-title="' + esc(p.title) + '">'
      + (inCart ? 'Switch to this size' : 'Add ' + qty + ' to cart') + '</button></div>';
  }

  function render(box, cart) {
    var wheel = cart.items.filter(isWheelItem)[0];          // newest wheel line
    var dia = wheel && diameterOf(wheel);
    if (!wheel || !dia) { box.hidden = true; box.dataset.state = ''; return Promise.resolve(); }
    var qty = wheel.quantity || 4;
    var tire = cart.items.filter(isTireItem)[0] || null;
    var s = saved();
    var state = [dia, qty, tire ? tire.key : '', s ? s.y + s.mk + s.mo + (s.sb || '') + (s.setup || '') : ''].join('|');
    if (box.dataset.state === state) { box.hidden = false; return Promise.resolve(); }
    box.dataset.state = state;
    var max = parseInt(box.dataset.cards, 10) || 3;
    var lead = box.querySelector('[data-wtu-lead]'), cards = box.querySelector('[data-wtu-cards]'), more = box.querySelector('[data-wtu-more]');

    return sizesFor(box, dia).then(function (rec) {
      if (box.dataset.state !== state) return;                 // a newer cart state won
      var have = tire ? normSize(tire.product_title || tire.title) : '';
      var candidates = rec.sizes.filter(function (x) { return !have || have.indexOf(normSize(x.size)) === -1; }).slice(0, max * 2);
      lead.textContent = tire
        ? 'You have ' + tire.quantity + ' × ' + (tire.product_title || tire.title) + '. Prefer a different size for your ' + dia + '" wheels?'
        : 'You just added ' + qty + ' × ' + dia + '" wheels' + (rec.vehicle ? ' for your ' + rec.vehicle : '') + '. Don’t forget tires!';
      return Promise.all(candidates.map(function (c) { return productsFor(c.size).then(function (ps) { return { rec: c, p: pick(ps, qty) }; }); }))
        .then(function (rows) {
          if (box.dataset.state !== state) return;
          var html = rows.filter(function (r) { return r.p; }).slice(0, max).map(function (r) { return card(r.rec, r.p, qty, !!tire); }).join('');
          cards.innerHTML = html;
          var all = '/collections/' + dia + '-tires';
          more.innerHTML = '<a href="' + all + '">See all ' + dia + '" tires' + (rec.vehicle ? ' that fit your ' + esc(rec.vehicle) : '') + ' →</a>';
          box.hidden = false;
        });
    }).catch(function () { box.hidden = true; });
  }

  // Add straight from the card. The fetch wrapper below sees the /cart/add.js call and
  // runs a refresh pass (dedupe + re-render); on the cart page we then reload so Dawn's
  // line items, totals, free-shipping notice and shipping protection all recompute.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wtu-add]'); if (!btn) return;
    var id = parseInt(btn.dataset.variant, 10), qty = parseInt(btn.dataset.qty, 10) || 4;
    if (!id) return;
    btn.disabled = true; btn.textContent = 'Adding…';
    nativeFetch('/cart/add.js', { method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty }] }) })
      .then(function (r) { if (!r.ok) throw new Error('add failed ' + r.status); return r.json(); })
      .then(function () { return refresh(); })
      .then(function () {
        if (/^\/cart\b/.test(window.location.pathname)) { window.location.reload(); return; }
        showToast('Added ' + qty + ' × ' + btn.dataset.title + ' to your cart');
        var bubble = document.getElementById('cart-icon-bubble'); if (bubble && window.fetch) {
          nativeFetch('/?sections=cart-icon-bubble').then(function (r) { return r.json(); })
            .then(function (j) { if (j['cart-icon-bubble']) bubble.innerHTML = new DOMParser().parseFromString(j['cart-icon-bubble'], 'text/html').body.innerHTML; }).catch(function () {});
        }
      })
      .catch(function (err) { btn.disabled = false; btn.textContent = 'Add ' + qty + ' to cart'; if (window.console) console.warn('[wbr-tire-upsell]', err); });
  });

  /* ---------- one pass, single-flight ---------- */

  var running = null, queued = false;
  function refresh() {
    if (running) { queued = true; return running; }
    running = getCart()
      .then(function (cart) {
        return dedupeTires(cart).then(function (kept) {
          if (!kept) return cart;
          showToast('Updated your tire to ' + (kept.product_title || kept.title));
          return getCart();
        });
      })
      .then(function (cart) { return Promise.all(widgets().map(function (b) { return render(b, cart); })); })
      .catch(function () {})
      .then(function () { running = null; if (queued) { queued = false; return refresh(); } });
    return running;
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { refresh(); }); else refresh();

  window.fetch = function (input, opts) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var promise = nativeFetch(input, opts);
    if (CART_MUTATION_RE.test(url)) promise.then(function () { refresh(); }).catch(function () {});
    return promise;
  };
})();
